export const SIGNAL_PREFIX = 'custom_';
export const signalPrefix = (name) => `${SIGNAL_PREFIX}${name}`;
